import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeLayers,
  FontAwesomeLayersText,
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  faSpinner as freeFasFaSpinner,
  faChartLine as freeFasFaChartLine,
  faMobileAlt as freeFasFaMobileAlt,
  faSearchDollar as freeFasFaSearchDollar,
  faRocket as freeFasFaRocket
} from '@fortawesome/free-solid-svg-icons'

import {
  faCheckCircle as freeFarFaCheckCircle
} from '@fortawesome/free-regular-svg-icons'

import {
  faAccessibleIcon as freeFabFaAccessibleIcon,
  faWhatsapp as freeFabFaWhatsapp
} from '@fortawesome/free-brands-svg-icons'

library.add(
  freeFasFaSpinner,
  freeFasFaChartLine,
  freeFasFaMobileAlt,
  freeFasFaSearchDollar,
  freeFasFaRocket,
  freeFarFaCheckCircle,
  freeFabFaAccessibleIcon,
  freeFabFaWhatsapp
)

config.autoAddCss = false

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('FontAwesomeLayers', FontAwesomeLayers)
Vue.component('FontAwesomeLayersText', FontAwesomeLayersText)
